module.exports = __webpack_public_path__ + "b79c7006a13a820e5cccf4fd1911ef15.svg";